function menu() {
    $('.menu').click(function (e) {
        $('.navbar .container .row').css('top', $('header').outerHeight());
        $('.navbar .submenu').css('max-height', 'calc(100vh - ' + $('header').outerHeight() + 'px)');
        if (!$('html').hasClass('menu-open')) {
            $('html').addClass('menu-open');
            bd.show();
        } else {
            $('html').removeClass('menu-open submenu-open');
            $('.submenu').removeClass('sys');
            bd.hide();
        }
    });

    $('.navbar li').each(function (i, v) {
        if ($(v).find('.submenu').length) {
            $(v).addClass('has-child');
        }
    });

    $('.js-show-userpanel').click(function () {
        if (!$(this).find('.subpanel').hasClass('sys')) {
            hidePanels();
            bd.show();
            $(this).find('.subpanel').addClass('sys');
        }
    });

    $('.js-show-lang').click(function () {
        if (!$(this).find('.subpanel').hasClass('sys')) {
            hidePanels();
            bd.show();
            $(this).find('.subpanel').addClass('sys');
        }
    });

    $('body').off().on('click', '.has-child', function (e) {
        if (!$(this).find('.submenu').hasClass('sys')) {
            hidePanels();
            $('.header .submenu').removeClass('sys');
            $('html').addClass('submenu-open');
            $(this).find('.submenu').addClass('sys');
            if (WW >= 991) {
                bd.show();
            } else {
                bd.show();
            }
        } else {
            if (!$(e.target).hasClass('submenu-link')) {
                $('.header .submenu').removeClass('sys');
                $('html').removeClass('submenu-open');

                if (WW >= 991) {
                    bd.hide();
                }
            }
        }
    });

    $('.js-showloginpanel').click(function () {
        $('.js-show-userpanel .wiacc-show-submenu').trigger('click');

    });
}

function profilOrders() {
    if ($('.order-elem-full-address').length) {

        $('.order-elem-full-address').each(function (i, v) {
            $(v).html(function () {
                return $(this).text().replace(/,/g, '<br/>');
            })
        });
    }
}

function basketSum() {
    var sum = 0;
    $('.cart .qty-input').each(function () {
        sum += Number($(this).val());
    });

    $('.cart-counter').text(sum);
}

function showCartLayer(statement) {
    hidePanels();

    if (statement == true) {
        $('.cart').addClass('easy-sys');
    } else {
        $('.cart').addClass('sys');
    }

    if (statement != true) {
        bd.show();
    }
}

function sliderRecomm() {
    var autoplay = $('.slider-recomm').data('autoplay'),
        speed = $('.slider-recomm').data('speed');

    $('.slider-recomm').on('init', function (event, slick) {
        setTimeout(function () {
            $(slick.$slides).each(function () {
                let slideElement = $(this);

                if (slideElement.is('div')) {
                    slideElement.attr('tabindex', '-1');
                }
            });
        }, 1000);
    }).slick({
        focusOnSelect: false,
        infinite: false,
        autoplay: autoplay,
        autoplaySpeed: speed,
        adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false
    }).on('afterChange', function (event, slick, currentSlide) {
        /*$(slick.$slides).each(function (index) {
            let slideElement = $(this);
            let hasATag = slideElement.find('a').length > 0;


            if (hasATag) {
                slideElement.attr('tabindex', '-1');
            } else {
                if (index === currentSlide) {
                    slideElement.attr('tabindex', '0');
                } else {
                    slideElement.attr('tabindex', '-1');
                }
            }
        });

        let currentSlideElement = $(slick.$slides[currentSlide]);
        let aTag = currentSlideElement.find('a').first();

        if (aTag.length > 0) {
            aTag.focus();
        } else {
            currentSlideElement.focus();
        }*/
    });

    $('.slider-recomm .slick-slide').each(function () {
        if ($(this).find('a').length === 0) {
            $(this).attr('tabindex', '-1');
        }
    });

}

function sliderCategories() {
    $('.slider-categories').on('init', function () {
        $(this).find('.slick-track').attr({
            'role': 'list',
            'aria-label': 'List'
        });
    }).slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: false,
        arrows: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1.1,
                    slidesToScroll: 1,
                    arrows: false,
                }
            }
        ]
    });
}

function updateClonedIds() {
    $('.slider-products .slick-slide.slick-cloned').each(function (index) {
        $(this).find('[aria-labelledby]').each(function () {
            const originalId = $(this).attr('aria-labelledby');

            const newId = originalId + '-clone-' + index;
            $(this).attr('aria-labelledby', newId);
            $(this).parents('.product-inner').find('.product-title').attr('id', newId);
        });
    });
}

function sliderProducts() {
    $('.slider-products').on('init', function (event, slick) {
        resizeBoxes('.product-list', '.product-title');
        resizeBoxes('.product-list', '.product-price');

        setTimeout(function () {
            updateClonedIds();
        }, 10);
    }).slick({
        rows: 1,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    arrows: false,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1.3,
                    arrows: false,
                }
            }
        ]
    });
}

function slideIconCategories() {
    $('.slider-iconcategories').slick({
        slidesToShow: 5,
        slidesToScroll: 5,
        dots: false,
        arrows: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    arrows: false,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2.2,
                    slidesToScroll: 1,
                    arrows: false,
                }
            }
        ]
    });
}

function cartLayer() {
    var docHeight = $(window).height();

    $('.cart').height(docHeight);

    $('.js-show-cart').click(function () {
        showCartLayer();
    });
}

function prodListPage() {
    $('.js-showcategories').click(function () {
        if (!$('.pl-mobilcat').hasClass('sys')) {
            $('.pl-mobilcat').addClass('sys').slideDown();
        } else {
            $('.pl-mobilcat').removeClass('sys').slideUp();
        }
    });

    if ($('.pl-mobilcat').empty()) {
        $('.product-category-item.active').clone().appendTo('.pl-mobilcat');
    }

}

function productPage() {
    $('.pp-image').addClass('sys');
    /*if ($('.pp-image img').length >= 2) {
        $('.pp-image').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true
        });
    } else {
        $('.pp-image').addClass('sys');
    }*/
}

function collapsableBox() {
    $('body').on('click', '.pp-data-header', function () {
        if (!$(this).parent().hasClass('sys')) {
            $('.pp-data-content').slideUp();
            $('.pp-data').removeClass('sys');

            $(this).parent().find('.pp-data-content').slideDown();
            $(this).parent().addClass('sys');
        } else {
            $(this).parent().find('.pp-data-content').slideUp(function () {
                $(this).parent().removeClass('sys');
            });

        }
    });
}

function hidePanels() {
    bd.hide();
    $('.subpanel, .search, .submenu, .cart').removeClass('sys');
    $('.cart').removeClass('easy-sys');
    $('.popup').removeClass('active');
}

function backdrop() {
    $('.backdrop, .popup-dismiss, .cart-close, .subpanel-close').click(function () {
        $('.popup').removeClass('sys active');
        bd.hide();

        cartLayerVisible = false;

        if ($('html').hasClass('menu-open')) {
            $('html').removeClass('menu-open submenu-open');
            $('.navbar-right, .submenu').removeClass('sys');
        }

        if ($('.cart').hasClass('sys') || $('.cart').hasClass('easy-sys')) {
            $('.cart').removeClass('sys easy-sys');
        }

        if ($('.search').hasClass('sys')) {
            $('.search').removeClass('sys')
        }

        if ($('.submenu').hasClass('sys')) {
            $('.submenu').removeClass('sys');
        }

        if ($('.product-category-ctn').hasClass('sys')) {
            $('.product-category-ctn').removeClass('sys');
        }

        if ($('.subpanel').hasClass('sys')) {
            $('.subpanel').removeClass('sys');

            return false;
        }
    });
}

function popup() {
    $(doc).on('click', '.show-popup', function () {
        var target = $(this).data('target');

        hidePanels();

        $('.popup').removeClass('active');
        $('.popup-' + target).addClass('active');

        if ($('.subpanel').hasClass('sys')) {
            $('.subpanel').removeClass('sys')
        }

        if ($('.cart').hasClass('sys') || $('.cart').hasClass('easy-sys')) {
            $('.cart').removeClass('sys easy-sys');
        }

        bd.show();

    }).on('click', '.popup-close, .popup-dismiss, .popup-btnclose', function () {
        bd.hide();
        $('.popup').removeClass('active');
        setTimeout(function () {
            bd.removeClass('sys');
        }, 400);
    });
}

function showPopup(target) {
    handleFocusTrap('.asd', 'popup-' + target);
    handleEscapeClose();

    var windowHeight = $(window).height();

    hidePanels();

    $('.popup').removeClass('active');
    $('.popup-' + target).addClass('active');

    bd.show();
}

function createNotification(text, type, source) {
    if (type == '') {
        type = 'success';
    }

    $('body').append('<div class="tr notification notification-' + type + '"><p class="h3 text-center text-uppercase">' + text + '</p>' + '</div>');

    setTimeout(function () {
        $('.notification').addClass('sys');
        if (source) {
            $(source).addClass('disable');
        }
    }, 100);
    setTimeout(function () {
        $('.notification').removeClass('sys').delay(400).queue(function () {
            $(this).remove();
            if (source) {
                $(source).removeClass('disable');
            }
        });
    }, 3000);
}

function notification() {
    $('body').on('click', '.create-notification', function () {
        var text = $(this).data('text'),
            type = $(this).data('type');

        createNotification(text, type, this);
    });
}

function tooltip() {
    $('.show-tooltip').click(function (e) {
        e.preventDefault();

        var $this = $(this),
            varText = $this.data('text');

        $('html').append($('<div class="tooltip"/>')
            .append($('<div class="tooltip-inner"/>')
                .append($('<div class="tooltip-content"/>')
                    .html(varText))
            )
        ).append($('<div class="backdrop-light sys"></div>'));


        var varTextHeight = $('.tooltip').not('.tooltip-sys').height();

        setTimeout(function () {
            $('.tooltip').not('.tooltip-sys').css({
                'top': $this.offset().top - (varTextHeight + 10),
                'left': $this.offset().left - ($('.tooltip').not('.tooltip-sys').width() / 2) + ($this.width() / 2),
                'z-index': '1003'
            });
        }, 100);
    });
}

function resizeBoxes(source, boxes) {
    if ($.type(source) === 'string') source = $(source);

    var h = 0;
    source.find(boxes).height('auto');
    source.find(boxes).each(function () {
        if ($(this).height() > h) h = $(this).height();
    });
    source.find(boxes).height(h);
}

function getOS() {
    var a = '';
    var osString = {
        'windows': /(Win)/,
        'android': /Android/,
        'linux': /(Linux|X11)/,
        'ios': /(iPhone|iPad|iPod|Mac)/,
        'unix': /UNIX/,
        'bot': /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
    };

    $.each(osString, function (k, v) {
        if (a == '' && v.test(navigator.userAgent)) a = k;
    });
    return a;
}

function getBrowser() {
    var a = '';
    var browserString = {
        'Chrome': 'chrome',
        'MSIE': 'ie',
        'Trident/': 'ie',
        'Firefox': 'ff',
        'Safari': 'safari',
        'Presto': 'opera',
        'Opera': 'opera'
    };
    $.each(browserString, function (k, v) {
        if (a == '' && navigator.userAgent.indexOf(k) != '-1') a = v;
    });
    return a;

}

/* apple-safari mobile rotation bug fixed */
if (os == 'ios' && browser == 'safari') {
    (function (doc) {
        var addEvent = 'addEventListener',
            type = 'gesturestart',
            qsa = 'querySelectorAll',
            scales = [1, 1],
            meta = qsa in doc ? doc[qsa]('meta[name=viewport]') : [];

        function fix() {
            meta.content = 'width=device-width,minimum-scale=' + scales[0] + ',maximum-scale=' + scales[1];
            doc.removeEventListener(type, fix, true);
        }

        if ((meta = meta[meta.length - 1]) && addEvent in doc) {
            fix();
            scales = [.25, 1.6];
            doc[addEvent](type, fix, true);
        }
    }(document));
}